import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useSelector, useDispatch } from "react-redux";
import {
  getClassData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearClassData,
  getTermData,
} from "../../reduxSlices/classesSlice";

import { isObjectEmpty } from "../../utils/general";
import { clearLoginData, isLoggedInUpdate } from "../../reduxSlices/loginSlice";
import Backdrop from "../Backdrop";
import Aux from "../../hoc/Auxilliary";
import MessageIndicator from "../SnackBar";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
  footer: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
});

function GradePage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [termsData, setTerms] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [tableMapData, setTableMapData] = useState([]);
  const classData = useSelector((state) => state.classData.classData);
  const terms = useSelector((state) => state.classData.terms);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );

  const errorMessage = useSelector((state) => state.classData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.classData.errorStatusCode,
  );

  useEffect(() => {
    dispatch(getClassData(window.localStorage.getItem("x-auth-contactId")));
    dispatch(getTermData());
  }, [dispatch]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
        );
    }
    return [];
  };

  useEffect(() => {
    if (!isObjectEmpty(classData)) setTableMapData(classData.data);
  }, [classData]);

  let tableData = "";
  let termData = "";
  if (!isObjectEmpty(classData.data)) {
    if (classData.data) {
      if (Array.isArray(classData.data)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_class}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_coursename}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_section}</StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditstaken
                          ? element.ses_creditstaken.toFixed(2)
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_classstatus}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_studentstatus}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_gradeoption}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_sessionpercenttodate}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_sessiongrade1}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_gradereceived}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditsearned}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_termname}</StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
        termData = removeDuplicateFromObjects(classData.data, "termName").map(
          (element, index) => (
            <MenuItem value={element.ses_termname} key={index}>
              {element.ses_termname}
            </MenuItem>
          ),
        );
      }
    }
  }

  const handleChange = (event) => {
    const copyTableMapData = [...classData.data];
    if (event.target.value.length === 0) {
      setTableMapData(copyTableMapData);
    } else {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_termname === event.target.value,
      );
      setTableMapData(copyData);
    }
    setTerms(event.target.value);
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <div style={{ minHeight: "60vh" }}>
        <Grid container>
          <Typography component="div" className={classes.classFont}>
            Grades
          </Typography>
        </Grid>
        <TableContainer
          component={Paper}
          style={{ minHeight: "40vh", marginBottom: "10px" }}
        >
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Class ID</StyledTableCell>
                <StyledTableCell>Course</StyledTableCell>
                <StyledTableCell>Class Section</StyledTableCell>
                <StyledTableCell>Credits</StyledTableCell>
                <StyledTableCell>Class Status</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Grading Option</StyledTableCell>
                <StyledTableCell>Complete</StyledTableCell>
                <StyledTableCell>Points</StyledTableCell>
                <StyledTableCell>Grade</StyledTableCell>
                <StyledTableCell>Credits Earned</StyledTableCell>
                <StyledTableCell>
                  <div className={classes.TableControl}>
                    <FormControl className={classes.formControl}>
                      <Select
                        value={termsData}
                        onChange={handleChange}
                        className={classes.formControl}
                        displayEmpty
                      >
                        <MenuItem value="">All Terms</MenuItem>
                        {termData}
                      </Select>
                    </FormControl>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tableData}</TableBody>
          </Table>
          <TablePagination
            style={{ textTransform: "capitalize" }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={tableMapData.length > 0 ? tableMapData.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>
    </Aux>
  );
}

export default withRouter(GradePage);
